<!-- eslint-disable vue/no-unused-vars -->
<template>
  <div>
    <div class="box">
      <div v-if="from !== 'exclusive'" class="msg">
        <div class="msgBox">
          <!-- arriveDistance:{{ arriveDistance }}--onLineFlag:{{ onLineFlag }}--active:{{ active }} -->
          <p class="msgTitle">您当前位置{{ formattedAddress }}</p>
          <div class="msgContent fvlr">
            <p>{{ formattedAddress }}</p>
            <p class="tip fvl" @click="relocation">
              <van-loading v-if="showLoading" class="address" color="#1989fa" size="14" />
              <img v-else src="../../../assets/images/address.svg" class="cb address" />
              重新定位
            </p>
          </div>
        </div>
        <div class="msgBox mbSecond" v-if="dealerInfo">
          <p class="msgTitle">经销商</p>
          <div class="msgContent">
            <p class="mbNine">{{ dealerInfo.name }}</p>
            <p class="tip">
              <span>{{ dealerInfo.address }}</span>
              <span>{{ dealerInfo.distance ? '距您约' + dealerInfo.distance + 'km' : '' }}</span>
            </p>
          </div>
        </div>
      </div>
      <div v-if="from !== 'exclusive'" class="tab">
        <div class="flvw tabList">
          <div v-if="shouldShop" :class="{ tabItem: true, active: active === 1 }" @click="changeActive(1)">
            到店订购
          </div>
          <div v-if="onLineFlag" :class="{ tabItem: true, active: active === 2 }" @click="changeActive(2)">
            在线预约<span class="recommend" v-if="betterLine && tyreCount > 1">推荐</span>
          </div>
          <div v-if="!onLineFlag" :class="{ tabItem: true, disable: active === 0 }" @click="changeActive(0)">
            在线预约
          </div>
        </div>
      </div>
      <div class="recommendSign" v-if="betterLine && tyreCount > 1 && shouldShop">
        推荐选择在线预约，因库存原因，到店订购方式只支持部分轮胎
      </div>
      <van-row class="card" v-for="(item, index) in tyreInfo" :key="item.id">
        <template v-if="(active === 2 && item.lineBuyFlag) || item.buyFlag">
          <van-col span="2"
            ><van-checkbox v-model="tyreCouponCheckArr[index]" @click="checkTyreCoupon(tyreCouponCheckArr[index], index)" shape="square"></van-checkbox
          ></van-col>
          <van-col span="7"><img src="../../../assets/images/tyre.png"/></van-col>
          <van-col span="13" class="content fhlud">
            <div class="name">
              <span class="fvlw">
                {{ item.brand?.name }}
                {{ item.moe ? `原配${item.moe}` : '' }}
                {{ item.spec }}&nbsp;{{ item.load_index }}{{ item.speed_rating }}&nbsp;{{ item.extra_load }}&nbsp;{{ item.pattern }}
              </span>
            </div>
            <p v-if="!item.shopBuyFlag && item.shopCount > 0" class="remainingTip">该配件的{{ item.shopCount }}件库存满足到店订购</p>
            <div>
              <span class="msrpText">厂商建议零售价*</span>&nbsp;
              <span class="msrp">¥{{ item.msrp }}</span>
            </div>
          </van-col>
          <van-col span="1" class="num">x{{ item.count }}</van-col>
          <van-col span="20" v-if="item.couponArr && item.couponArr.tyreRightVoList.length">
            <van-row style="margin-top:10px">
              <van-col span="15">轮胎套餐优惠券</van-col>
              <van-col span="24"
                ><van-checkbox-group v-model="form[index]" :disabled="tyreLoad" direction="horizontal">
                  <van-checkbox v-for="i in item.couponArr.tyreRightVoList" @click="getTyreCoupons" :disabled="i.useType == 0" :key="i.id" :name="i.id"
                    ><span :class="tyreCouponCheckArr[index] ? '' : 'graySty'">{{ i.rightName }}</span></van-checkbox
                  >
                </van-checkbox-group>
              </van-col>
            </van-row>
          </van-col>
        </template>
      </van-row>
      <div v-if="from === 'exclusive'">
        <ServiceType class="serviceType" />
        <div class="fvlru common common1">
          <div class="left">服务类型</div>
          <div class="right">
            【尊享】轮胎保障服务
            <p>(70% 补偿费用 - 待审核)</p>
          </div>
        </div>
        <div class="fvlr common">
          <div class="left">经销商</div>
          <div class="right">{{ customerInfo.dealer?.name }}</div>
        </div>
      </div>
      <div class="form">
        <div class="formTitle">填写订单信息</div>
        <div class="appointTime" v-if="active === 2">
          <div class="fvlr timeBox">
            <div class="fvlw">
              <div class="van-cell__title van-field__label">
                <span>预约时间</span>
              </div>
              <div>{{ appointTime }}</div>
            </div>
            <van-icon size="18" name="calendar-o" @click="showCalendar++" />
          </div>
          <p class="tip">
            可选时间范围已预留经销商备货时间，如需其他时间到店，请致电经销商进行详细咨询
          </p>
        </div>
        <van-form>
          <van-field v-model="customerInfo.username" placeholder="请输入姓名" label="姓名" />
          <van-field
            name="mobile"
            v-model="customerInfo.phone"
            placeholder="请输入联系方式"
            type="tel"
            label="联系方式"
            :rules="[{ required: true, message: '请输入联系方式' }]"
          />
          <van-field name="plate" required v-model="customerInfo.licensePlate" placeholder="请输入车辆牌号" label="车辆牌号" />
        </van-form>
        <div class="imgBox">
          <p class="title fvl">
            轮胎照片 &nbsp;&nbsp;
            <van-icon @click="showTip" class="warning" color="#cccccc" name="warning" />
          </p>
          <div class="imgList" @click="addImg">
            <div
              v-for="(item, index) in tyreImgList"
              :key="index"
              :class="{ 'image-wrapper': true, 'fix-horizontal-space': index % 4 !== 3, 'fix-vertical-space': index <= 3 && tyreImgList.length + 1 > 4 }"
            >
              <div class="image-cover" v-if="item.localData" :style="{ backgroundImage: `url(${item.localData})` }"></div>
              <div class="image" v-else>
                <img class="default-image" :src="item.defaultImagePath" />
              </div>
              <div v-if="item.position" class="tag">
                <div>{{ item.position.tag }}</div>
              </div>
            </div>
            <div v-if="tyreImgList.length < 8" class="addImg fc">+</div>
            <div class="empty" v-for="i in 8 - tyreImgList.length" :key="i"></div>
          </div>
        </div>
      </div>
      <div v-if="from !== 'exclusive'" class="settlement">
        <div class="formTitle">使用优惠信息</div>
        <div class="fvl coupon" :class="{ noLabel: index > 0 }" v-for="(item, index) in sixCouponList" :key="item">
          <van-checkbox @change="checkSixCoupon" v-model="sixCouponCheck" shape="square"></van-checkbox>
          <van-field
            v-model="couponNumList[`c${index}`]"
            @blur="getSixCoupon(index, 'index')"
            @clear="getSixCoupon(index)"
            :formatter="upCase"
            maxlength="6"
            center
            clearable
            label="使用6位码优惠券"
            placeholder="请输入6位优惠券编码"
          >
            <template #button>
              <div class="addImg fc addCoupon" v-if="tyreCount > sixCouponList.length" @click="addSixCoupon">
                +
              </div>
            </template>
          </van-field>
        </div>
        <div class="fvlr coupon" v-if="couponInfo.length > 0">
          <div class="fvlw">
            <van-checkbox v-model="mallCouponCheck" shape="square" @change="checkMallCoupon"></van-checkbox>
            <div class="mallCoupon">使用商城优惠券</div>
            <template v-if="preferential && preferential.length > 0">
              <p class="couponMsg" v-for="item in preferential" :key="item.id">
                {{ item.tyreThresholdStr }}
              </p>
            </template>
          </div>
          <div @click="showDiscountUseDetail()">
            <van-icon class="fvlw" name="arrow" />
          </div>
        </div>
        <!-- <div v-if="tyrecouponList.length" class="fvlr tyreconpou">
          <div class="fvlw">
            <van-checkbox v-model="tyreCouponCheck" @change="checkTyreCoupon" shape="square"></van-checkbox>
            <div class="mallCoupon">使用轮胎套餐优惠券</div>
          </div>
          <div @click="activeCoupon = !activeCoupon">
            <van-icon class="fvlw" :name="activeCoupon ? 'arrow-down' : 'arrow-up'" />
          </div>
        </div>
        <div style="padding-left:25px" v-if="activeCoupon">
          <div v-for="(item, index) in tyrecouponList" :key="item.tyreNo">
            <div>{{ item.brand }}</div>
            <van-checkbox-group v-model="form[index]" :disabled="tyreLoad">
              <van-checkbox v-for="i in item.tyreRightVoList" @click="getTyreCoupons" :disabled="i.useType == 0" :key="i.id" :name="i.id">{{
                i.rightName
              }}</van-checkbox>
            </van-checkbox-group>
          </div>
        </div> -->
      </div>
      <div class="settlement" v-if="active > 0 && !CouponNum">
        <div class="formTitle">结算信息</div>
        <div class="fvlr common common1">
          <div class="left">厂商建议零售价合计</div>
          <div class="left">¥{{ allMsrp }}</div>
        </div>
        <div class="fvlr common">
          <div class="left">经销商自主报价合计</div>
          <div class="left">¥{{ productPrice }}</div>
        </div>
        <div class="fvlr common">
          <div class="left">优惠金额</div>
          <div class="discount">-¥{{ subtractPrice }}</div>
        </div>
        <div class="result">
          待付金额&nbsp;<span class="cb">¥{{ actualPrice }}</span>
        </div>
        <div class="tip fvr"><van-icon name="question-o" />&nbsp;&nbsp;已更新为经销商为您提供的最终优惠</div>
      </div>
      <div class="settlement submitBox fvlr" v-if="active > 0">
        <div class="fvl">
          <van-checkbox v-model="isSubmitRule" icon-size="16px" shape="square"></van-checkbox>
          &nbsp;&nbsp; 本人同意
          <a class="protocol" @click="showDeal++">用户服务协议</a>
        </div>
        <van-button class="btn" :disabled="(!isSubmitRule && submitAble) || !hasLoadStock" @click="isSumitOrder"> {{ sumitOrderTxt }} </van-button>
      </div>
      <van-overlay class="load-overlay" :show="showOnLineOverlay">
        <div class="wrapper" @click="goBack">
          <van-icon name="fail" size="30" />
          <p>{{ disableOnLineStr }}</p>
        </div>
      </van-overlay>
      <!-- <p class="disableOnLine" v-if="active === 0">{{ disableOnLineStr }}</p> -->
    </div>
    <DiscountUseDetail
      :showPopUp="showPopUp"
      :datas="{ totalPrice: null, couponListData: couponInfo, tyreSelectedList: tyre, defaultCoupon: shoppingCoupon }"
      :preferential="preferential"
      @setPreferential="setPreferential"
      :fromOrder="true"
      ref="discountUseDetailRef"
    />
    <Calendar :dealerInven="dealerInven" :earliest="earliest" :showCalendar="showCalendar" @setAppointTime="setAppointTime" />
    <!-- <ServiceDeal :showDeal="showDeal" /> -->
    <SubmitOrder ref="showSubmitOrderPopUp" />
    <van-overlay class="load-overlay" :show="amditLoading">
      <van-loading size="30px" vertical></van-loading>
    </van-overlay>
    <PopUp :showPopUp="showDeal" :datas="contractData" :lockScroll="false">
      <ServiceDeal :datas="contractData.contents" />
    </PopUp>
    <van-action-sheet v-model:show="showVisible" :closeable="false" title="轮胎优惠券使用通知">
      <div class="contentTip">
        此处为您计算的价格仅为优惠后的轮胎的价格，不包含工时。最终支付价格以经销商价格为准。
      </div>
      <div>
        <van-button type="default" class="btnW" @click="showVisible = false">取消</van-button>
        <van-button type="primary" class="btnW" @click="sumitOrder">已知晓</van-button>
      </div>
    </van-action-sheet>
  </div>
</template>
<script>
export { default } from '@/util/tyre/order.js'
</script>

<style lang="scss" scoped>
.graySty {
  color: gray;
}
::v-deep .van-action-sheet__header {
  font-size: 17px;
  color: red;
}
.contentTip {
  padding: 20px 30px;
  text-align: left;
  font-weight: 450;
  font-size: 16px;
  text-indent: 2em;
}
.btnW {
  width: 50%;
}
.flexsty {
  display: flex;
  justify-content: start;
  align-items: center;
}
.load-overlay {
  :deep(.van-loading) {
    position: absolute;
    top: 50%;
    left: 50%;
    transition: transform(-50%);
    transform: translate(-50%, -50%);
  }
}
.remainingTip {
  color: #ffb316;
  font-size: 12px;
}
.noLabel {
  :deep(.van-checkbox),
  :deep(.van-field__label) {
    visibility: hidden;
  }
}
.address {
  width: 15px;
  height: 15px;
  margin-right: 5px;
}
.addCoupon {
  font-size: 16px;
  transform: scale(1.2);
}
.mallCoupon {
  font-size: 14px;
  margin-left: 6px;
  margin-right: 25px;
  color: #646566;
}
.fvlw {
  margin-bottom: 20px;
}
.coupon {
  padding: 5px 20px;
  box-sizing: border-box;
  :deep(.van-cell::after) {
    content: none !important;
  }
  .borderNone {
    visibility: hidden;
  }
  .couponMsg {
    margin-right: 7px;
    padding: 3px 6px 3px 9px;
    border-radius: 10px;
    border: solid 1px #3088c5;
    font-size: 12px;
    color: #3088c5;
  }
  :deep(.van-cell) {
    padding: 3px 0 3px 6px;
    border-bottom: 0;
  }
  :deep(.van-cell__title) {
    width: 8.2em;
  }
  .van-checkbox {
    padding-right: 2px;
    :deep(.van-checkbox__icon) {
      height: auto;
      .van-icon {
        font-size: 0.6em;
      }
    }
  }
}
.tyreconpou {
  padding: 0px 20px;
  box-sizing: border-box;
  :deep(.van-cell::after) {
    content: none !important;
  }
  .borderNone {
    visibility: hidden;
  }
}
.van-checkbox {
  padding-right: 2px;
  :deep(.van-checkbox__icon) {
    height: auto;
    .van-icon {
      font-size: 0.6em;
    }
  }
}
.box {
  padding-top: 16px;
  .msg {
    padding: 12px 20px;
    background-color: #fff;
    text-align: left;
  }
  .mbSecond {
    margin-top: 16px;
  }
  .msgBox {
    .msgTitle {
      font-size: 12px;
      color: #999999;
    }
    .msgContent {
      font-size: 14px;
      color: #333333;
      margin-top: 8px;
      p {
        line-height: 14px;
      }
      .mbNine {
        margin-bottom: 9px;
      }
      .tip {
        font-size: 12px;
        color: #666666;
      }
    }
  }
  .disableOnLine {
    margin: 20px;
  }
}
.tabList {
  // margin-top: 8px;
  display: flex;
  .tabItem {
    width: 50%;
    color: #323233;
    font-weight: 500;
    margin-top: 8px;
    padding: 8px 0px;
    font-size: 14px;
    background-color: #f5f5f5;
    .recommend {
      width: 40px;
      height: 16px;
      margin: 0 0 0 8px;
      padding: 2px 8px;
      border: solid 0.5px var(--bluish);
      background-color: rgba(48, 136, 197, 0.1);
      font-size: 12px;
      color: #3088c5;
    }
  }
  .active {
    background-color: #fff;
    font-weight: 700;
  }
  .disable {
    background-color: #e3e3e3;
    color: #f3f3f3;
    font-weight: 700;
  }
}
.recommendSign {
  padding: 12px 0px;
  text-align: center;
  font-size: 12px;
  color: #3088c5;
  background-color: #fff;
}
.card {
  padding: 12px 20px;
  box-sizing: border-box;
  background: #fff;
  img {
    width: 120px;
    height: 90px;
  }
}
.content {
  text-align: left;
  display: flex !important;
}
.name {
  font-size: 14px;
  color: #333333;
  span {
    padding-right: 8px;
    word-wrap: break-word;
    word-break: normal;
    word-break: break-all;
  }
}
.msrpText {
  color: #666666;
}
.msrp {
  font-size: 16px;
  font-weight: 600;
  color: #3088c5;
}
.num {
  font-size: 14px;
  color: #666666;
}
.formTitle {
  padding: 16px 20px 12px;
  font-size: 16px;
  font-weight: 600;
  color: #333333;
}
.settlement {
  text-align: left;
  background: #fff;
  border-bottom: 1px solid #eeecec;
  padding-bottom: 10px;
  margin-top: 20px;
  color: #333333;
  .common {
    padding: 0 20px 12px;
    font-size: 14px;
    .left {
      color: #666666;
    }
  }
  .common1 {
    padding-top: 12px;
  }
  .discount {
    color: #c30000;
  }
  .result {
    text-align: right;
    font-size: 14px;
    padding: 0 20px 8px;
    box-sizing: border-box;
  }
  .tip {
    color: #999999;
    text-align: right;
    padding: 0 20px 8px;
    box-sizing: border-box;
  }
}
.form {
  background: #fff;
  text-align: left;
  margin-top: 12px;
  .appointTime {
    padding: 0.4rem 0.53333rem;
    position: relative;
    .timeBox {
      padding-bottom: 12px;
      font-size: 14px;
      .fvlw {
        margin-bottom: 0px;
      }
    }
    .tip {
      font-size: 12px;
      line-height: 1.5;
      color: #3088c5;
    }
    &::after {
      content: ' ';
      position: absolute;
      box-sizing: border-box;
      pointer-events: none;
      right: 0.42667rem;
      bottom: 0;
      left: 0.42667rem;
      border-bottom: 0.02667rem solid #ebedf0;
      -webkit-transform: scaleY(0.5);
      transform: scaleY(0.5);
    }
  }
  .imgBox {
    padding: 12px 20px;
  }
  .title {
    color: #646566;
    margin-bottom: 12px;
    font-size: 14px;
  }
  .van-cell {
    padding: 15px 20px;
  }
  .imgList {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .empty {
    width: 21.6vw;
    height: 0;
  }
  img,
  .addImg {
    width: 21.6vw;
    height: 21.6vw;
    margin-bottom: 1.8667vw;
    font-size: 32px;
    background: #fdfdfd;
    color: #dcdee0;
    border-radius: 3px;
    border: 1px solid #d4d2d2;
    box-sizing: border-box;
  }
}
.submitBox {
  height: 48px;
  padding: 0 0 0 20px;
  box-sizing: border-box;
  margin-bottom: 60px;
}
.protocol {
  color: #3088c5;
  border-bottom: 1px solid #3088c5;
}
.btn {
  height: 100%;
  line-height: 4;
  color: #fff;
  padding: 0 25px;
}
.van-cell--required::before {
  left: 12px;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #fff;
  flex-direction: column;
  p {
    margin: 5px 20px;
    font-size: 14px;
    line-height: 22px;
  }
}
</style>
